module.exports = __webpack_public_path__ + "static/media/timelify-light.38e58d62.otf";